package org.matthewo.pages.event.tabs

import emotion.react.css
import org.matthewo.api.Schedule
import org.matthewo.pages.event.EventTabFC
import org.matthewo.routes.API
import org.matthewo.table.MatchesTable
import react.dom.html.ReactHTML.div
import web.cssom.array
import web.cssom.em

val EventMatchesTable = EventTabFC<API.Event.Matches, List<Schedule.Match>>({
    API.Event.Matches(it)
}) { (coroutineScope, year, eventCode, data) ->
    div {
        css {
            margin = array(0.em, 1.em)
        }
        MatchesTable {
            this.year = year ?: 0
            code = eventCode ?: ""
            matches = data ?: []
            team = null
        }
    }
}
